<template>
  <div class="filter-footer mb-16">
    <CustomButton
      @click="closeFilter"
      class="mb-16"
      :disabled-state="!isFilterApplied"
      :button-color="ButtonColor.PRIMARY"
      :button-size="ButtonSize.SMALL"
      >Nachrichten filtern
    </CustomButton>
    <CustomButton
      @click="resetFilter"
      class="mb-16"
      :disabled-state="!isFilterApplied"
      :button-color="ButtonColor.SECONDARY"
      :button-size="ButtonSize.SMALL"
      >Filter zurücksetzen
    </CustomButton>
  </div>
</template>
<script setup lang="ts">
import { ButtonColor, ButtonSize, CustomButton } from 'de-zurich-ui-library'
import {
  type PostboxPolicy,
  PostboxStatus,
  PostboxZeitraum
} from '@/types/postbox/postbox-types'

defineProps<{
  postboxStatus: PostboxStatus
  postboxZeitraum: PostboxZeitraum
  postboxPolicies: Array<PostboxPolicy>
  isFilterApplied: boolean
}>()

const emit = defineEmits<{
  resetFilter: []
  closeFilter: []
}>()

const resetFilter = () => {
  emit('resetFilter')
}

const closeFilter = () => {
  emit('closeFilter')
}
</script>
<style lang="scss" scoped>
.filter-footer {
  padding-left: calc(12px);
  padding-right: calc(12px);
  padding-top: 16px;
  background-color: white;
}

.is-desktop .filter-footer {
  border-radius: 0 0 10px 10px;
}

.data-table th {
  font-weight: 600;
}
</style>
